<template>
	<v-layout row wrap>
		<v-flex xs12 md8>
			<v-layout row wrap>
				<v-flex xs12>
					<ValidationProvider name="title" v-slot="{ errors, valid }">
						<form-localized-input
							v-model="item.title"
							:errors="errors"
							:valid="valid"
						>
						</form-localized-input>
					</ValidationProvider>
				</v-flex>

				<v-flex xs12>
					<ValidationProvider
						name="description"
						v-slot="{ errors, valid }"
					>
						<form-localized-editor
							v-model="item.description"
							:errors="errors"
							:valid="valid"
						>
						</form-localized-editor>
					</ValidationProvider>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 class="pl-10">
			<v-layout row wrap>
				<v-flex xs12 md12>
					<v-card>
						<v-card-title primary-title>
							<h3>{{ $t("label.image") }}</h3>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<app-media-library
								v-model="item.image"
							></app-media-library>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		props: ["value"],

		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
	};
</script>
